import styled, { css } from 'styled-components';

export const PaginationContainer = styled.div<{ $isPashaLanding?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #fff;
  margin-top: ${({ $isPashaLanding }) => ($isPashaLanding ? '30px' : '0')};
`;

export const sharedButtonStyle = css`
  width: 28px;
  height: 28px;
  font-size: 14px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    color: #fff;
  }

  &:disabled {
    color: #555;
    cursor: default;
  }
`;

export const Page = styled.button<{ isActive?: boolean }>`
  ${sharedButtonStyle}
  ${({ isActive }) =>
    isActive &&
    css`
      background-color: rgba(38, 40, 43, 0.8);
      color: #fff;
    `}
`;

export const Ellipsis = styled.span`
  width: 28px;
  text-align: center;
  cursor: default;
  color: rgba(255, 255, 255, 0.8);
`;
